// import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
// import { MuiCustomBreakPoints } from '~/styles';
import ReactGA from 'react-ga';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

import { HomePage } from '~/pages';

// const theme = createTheme({
//   breakpoints: {
//     values: {
//       xs: 0,
//       sm: 425,
//       md: 768,
//       lg: 1024,
//       xl: 1536,
//     },
//   },
// });
const breakpoints = createBreakpoints({})
const theme = createTheme({
  palette: {
    // primary: {
    //   main: "#00B07B",
    //   contrastText: "#FFFFFF",
    // },
    // secondary: {
    //   main: "#0CAE7D",
    //   contrastText: "#FFFFFF",
    // },
    text: {
      primary: '#FFFFFF',
      secondary: '#F69501',
      // disabled: "#C4E5DD",
    },
    // error: {
    //   main: "#F93D3D",
    // },
    // common: {
    //   white: "#E4F2EF",
    // },
  },
  typography: {
    fontFamily: 'Poppins',
    h6: {
      lineHeight: '110%',
      fontWeight: '600',
      fontSize: '40px',
      color: 'white',
    },
    h5: {
      // lineHeight: 2,

      fontWeight: '600',
      fontSize: '16px',
      color: '#F69501',
    },
    body2: {
      lineHeight: 2,

      fontWeight: '400',
      fontSize: '14px',
      // color: 'white',
      color: '#c6c6c6',

      // color: "black",
    },
    body1: {
      // lineHeight: 2,

      fontWeight: '600',
      fontSize: '20px',
      color: '#fff',
      // color: "black",
    },
    subtitle1: {
      // lineHeight: 2,

      fontWeight: '600',
      fontSize: '16px',
      color: 'white',

      // color: 'white',
    },
  },

});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <HomePage />
    </ThemeProvider>
  );
};

export default App;
